import { render, staticRenderFns } from "./brandShop.vue?vue&type=template&id=95b73a72&scoped=true"
import script from "./brandShop.vue?vue&type=script&lang=js"
export * from "./brandShop.vue?vue&type=script&lang=js"
import style0 from "./brandShop.vue?vue&type=style&index=0&id=95b73a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b73a72",
  null
  
)

export default component.exports